module.exports = __webpack_public_path__ + "static/media/credit-card.1b8587cc.svg";